const A_REGEX = /<a([^<>]+)>/g;
const CLASS_ATTRIBUTE_REGEX = /class=["']([^"']*)["']/;
export function addClassNameToLinksInsideContent(content, linkClassName) {
    return content.replaceAll(A_REGEX, (_, attributes) => {
        const currentClasses = CLASS_ATTRIBUTE_REGEX.exec(attributes)?.[1];
        const newAttributes = currentClasses
            ? attributes.replace(CLASS_ATTRIBUTE_REGEX, '')
            : attributes;
        const newClassName = `${linkClassName} ${currentClasses || ''}`;
        return `<a${newAttributes} class="${newClassName}">`;
    });
}
